import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '@hook/query/queryKeys'
import {apiGetNotificationCount} from '@api/user/account/notification/getNotificationCount'
import {useLoginStore} from '@store/LoginStore'

const useQueryGetNotificationCount = (enabled: boolean = true) => {
    const id = useLoginStore(state => state.id)
    return useQuery({
        queryKey: QueryCacheKeys.notification.getNotificationCount(id),
        enabled: enabled,
        staleTime: 120 * 1000,
        cacheTime: 120 * 1000,
        queryFn: async () => {
            const {data} = await apiGetNotificationCount()
            if (data) return data
            return 0
        },
    })
}

export default useQueryGetNotificationCount
